import React from 'react';

import { ICON_NAMES, MaterialDesignIcon } from '../util/material-design-icons';
import { DoubleProgressBar } from '../widgets/double-progress-bar';

type InputProps = {
  successfulCount: number;
  failedCount: number;
  totalCount: number;
  actionText: string;
  className?: string;
};

export const UiProgressBar = (props: InputProps) => {
  const { successfulCount, failedCount, totalCount, actionText, className } = props;

  return (
    <div className={className}>
      <div className="u-display-flex u-alignItems-flexEnd u-margin-bottom-sm">
        <div className="typo-subtitle u-color-primary u-margin-right-sm">
          {successfulCount} of {totalCount} {actionText}
        </div>
        <MaterialDesignIcon
          iconName={ICON_NAMES.CHECK}
          color="primary"
          className="u-margin-right-sm"
        />
        {failedCount > 0 ? (
          <>
            <div className="typo-subtitle u-color-secondary u-margin-right-sm">
              {failedCount} failed
            </div>
            <MaterialDesignIcon
              iconName={ICON_NAMES.WARNING}
              color="secondary"
              className="u-margin-right-sm"
              size="sm"
            />
          </>
        ) : null}
      </div>
      <DoubleProgressBar
        variant="buffer"
        primaryCount={(successfulCount * 100) / totalCount}
        secondaryCount={((failedCount + successfulCount) * 100) / totalCount}
      />
    </div>
  );
};
